<template>
    <div>
        <div class="wrapper">
            <div class="col12 pt-0">
                <h1 class="page_title">機器レンタルプランのお申し込み</h1>
                <div class="signup_flow">
                    <ol>
                        <li><span>1</span>ログ <br class="on-sp" />イン</li>
                        <li><span>2</span>申込 <br class="on-sp" />内容</li>
                        <li class="current"><span>3</span>情報 <br class="on-sp" />入力</li>
                        <li><span>4</span>支払</li>
                        <li><span>5</span>完了</li>
                    </ol>
                </div>
                <!-- signup_flow -->
            </div>
        </div>
        <!-- wrapper -->

        <section class="container">
            <div class="wrapper">
                <h2 class="col5 section_title">
                    <strong>お申込み内容の確認</strong>
                </h2>
                <div class="col7 wrap_pr_2col input_area">
                    <h4 class="application_name">お支払い金額</h4>
                    <h3 class="strong big-16 mb-05em">初期費用</h3>
                    <ul class="default_list local">
                        <li>
                            <span>価格</span>
                            <span>&yen;0</span>
                        </li>
                        <li>
                            <span class="under_line">クーポン利用</span>
                            <span class="under_line">-</span>
                        </li>
                        <li>
                            <span>合計</span>
                            <span>&yen;0-(税込)</span>
                        </li>
                    </ul>
                    <h3 class="strong big-16 mb-05em">月額費用</h3>
                    <ul class="default_list local">
                        <li>
                            <span>料金</span>
                            <span>&yen;{{ formatCommafy(params.monthAmount) }}</span>
                        </li>
                        <li>
                            <span class="under_line">クーポン利用</span>
                            <span class="under_line">
                                <div v-if="discountSubscription > 0">&yen;-{{ formatCommafy(discountSubscription) }}</div>
                                <div v-else>-</div>
                            </span>
                        </li>
                        <li>
                            <span>合計</span>
                            <span
                                >&yen;{{ formatCommafy(params.monthAmount - discountSubscription) }}-(税込)
                                <div v-if="params.durationInMonths > 0">／ {{ params.durationInMonths }}ヶ月目以降 &yen;{{ formatCommafy(params.monthAmount) }}-(税込)</div></span
                            >
                        </li>
                    </ul>

                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('Agree')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">契約者情報</h4>
                    <dl>
                        <dt>お名前</dt>
                        <dd>{{ params.customerName }}</dd>
                    </dl>
                    <dl>
                        <dt>フリガナ</dt>
                        <dd>
                            {{ params.customerKana ? params.customerKana : "(入力なし)" }}
                        </dd>
                    </dl>
                    <dl>
                        <dt>郵便番号</dt>
                        <dd>{{ params.customerPostalCode }}</dd>
                    </dl>
                    <dl>
                        <dt>都道府県</dt>
                        <dd>{{ params.customerPrefecture }}</dd>
                    </dl>
                    <dl>
                        <dt>ご住所</dt>
                        <dd>{{ params.customerCity }}{{ params.customerAddress }}</dd>
                    </dl>
                    <dl>
                        <dt>電話番号</dt>
                        <dd>{{ params.customerTel }}</dd>
                    </dl>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('ContractForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">配送先情報</h4>
                    <div v-show="params.copyAddress">
                        <dl>
                            <dd>契約者と同じ住所に配送する</dd>
                        </dl>
                    </div>
                    <div v-show="!params.copyAddress">
                        <dl>
                            <dt>お名前</dt>
                            <dd>{{ params.destinationName }}</dd>
                        </dl>
                        <dl>
                            <dt>フリガナ</dt>
                            <dd>
                                {{ params.destinationKana ? params.destinationKana : "(入力なし)" }}
                            </dd>
                        </dl>
                        <dl>
                            <dt>郵便番号</dt>
                            <dd>{{ params.destinationPostalCode }}</dd>
                        </dl>
                        <dl>
                            <dt>都道府県</dt>
                            <dd>{{ params.destinationPrefecture }}</dd>
                        </dl>
                        <dl>
                            <dt>ご住所</dt>
                            <dd>{{ params.destinationCity }}{{ params.destinationAddress }}</dd>
                        </dl>
                        <dl>
                            <dt>電話番号</dt>
                            <dd>{{ params.destinationTel }}</dd>
                        </dl>
                    </div>
                    <!-- add_info -->
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('ContractForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">お申込み者様情報</h4>
                    <dl>
                        <dt>お申込み者様の性別</dt>
                        <dd>{{ params.ownerGenderLabel }}</dd>
                    </dl>
                    <dl>
                        <dt>お申込み者様の年代</dt>
                        <dd>{{ params.ownerAgeGroup }}</dd>
                    </dl>
                    <dl>
                        <dt>お申込み者様のお住まいの地域</dt>
                        <dd>{{ params.ownerPrefecture }} {{ params.ownerArea }}</dd>
                    </dl>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('SetupEmoForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">お届け日の指定</h4>
                    <dl>
                        <dt>お届け日時</dt>
                        <dd>{{ params.deliveryDateLabel }}{{ params.deliveryTimeLabel }}</dd>
                    </dl>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('SetupEmoForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">emo設定情報</h4>
                    <dl>
                        <dt>emoを主に利用する人の名前</dt>
                        <dd>{{ params.emoUserName }}</dd>
                        <dd v-if="params.emoUserNameText">({{ params.emoUserNameText }})</dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人の性別</dt>
                        <dd>{{ params.emoUserGenderLabel }}</dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人の年代</dt>
                        <dd>{{ params.emoUserAgeGroup }}</dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人のお住まいの地域</dt>
                        <dd>{{ params.emoPrefecture }} {{ params.emoArea }}</dd>
                    </dl>
                    <dl>
                        <dt>emoを主に利用する人とお申込み者様の関係</dt>
                        <dd>{{ params.emoUserRelationship }}</dd>
                        <dd v-if="params.emoUserRelationshipText">({{ params.emoUserRelationshipText }})</dd>
                    </dl>
                    <dl>
                        <dt>ファーストメッセージ</dt>
                        <dd>
                            {{ params.firstMessage ? params.firstMessage : "(入力されていません。)" }}
                        </dd>
                    </dl>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('SetupEmoForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <h4 class="application_name">アンケート</h4>
                    <dl>
                        <dt>emoを知った最初のきっかけを教えてください。</dt>
                        <dd>{{ params.ownerAnswer1 }}{{ `${params.ownerAnswer1SubAnswer ? "(" + params.ownerAnswer1SubAnswer + ")" : ""}` }}</dd>
                        <dd v-if="params.ownerAnswer1Text">
                            {{ params.ownerAnswer1Text }}
                        </dd>
                    </dl>
                    <p class="submit_btn no-check arrow-back">
                        <a href="javascript:void(0)" @click="modifyContent('SetupEmoForm')">修正する</a>
                    </p>

                    <hr class="thick" />

                    <dl>
                        <dd class="break-all">お申込み完了後のキャンセル・返品・解約について</dd>
                    </dl>
                    <dl>
                        <dd class="break-all">
                            ・お申込みを完了した当日18時まで（18時以降のお申込みに関しては翌日18時まで）に、お問合せフォーム等によりご連絡（※１）いただくことで、お申込みのキャンセル（費用のご負担なしでの解約）を承ります。
                        </dd>
                    </dl>
                    <dl>
                        <dd class="break-all">
                            ・本商品は LTE 通信を利用しているため、サービスエリア内であっても電波条件によってはご利用できないことがあります。その場合は、サービス利用開始日 ( 商品到着日 )
                            より 7 日以内にお問合せフォーム等によりご連絡（※１）いただくことで、解約金をいただかずに解約を承ります。
                        </dd>
                    </dl>
                    <dl>
                        <dd class="break-all">
                            ・レンタルサービスを解約される場合は、弊社ポータルサイトにてお手続き（※２）ください。本サービスの最低利用期間（サービス利用開始日より12ヶ月以内）内での解約は、解約金8,800円(税込)をご請求します。
                        </dd>
                    </dl>
                    <dl>
                        <dd class="break-all">※１　お問合せ窓口：（WEB）https://www.necolico.co.jp/contact/support_emo/（電話）03-5205-4468</dd>
                    </dl>
                    <dl>
                        <dd class="break-all">
                            ※２　ネコリコポータルの「サービス管理」＞「契約変更」＞「解約(更新停止)」を押していただき、画面の指示に従ってください。「更新停止完了」と画面に表示されると解約完了です。
                        </dd>
                    </dl>

                    <p class="submit_btn">
                        <input type="submit" value="この内容で申し込む" @click="confirm" />
                    </p>
                    <p class="submit_btn no-check no-arrow mt-3em">
                        <a href="javascript:void(0)" @click="cancel">キャンセル</a>
                    </p>
                </div>
                <!-- wrap_pr_2col input_area -->
            </div>
            <!-- wrapper -->
        </section>
        <!-- container -->
    </div>
</template>

<script>
export default {
    beforeRouteEnter(to, from, next) {
        // 特定の画面以外からの遷移は禁止
        if (from.name !== "SetupEmoForm") {
            next({ name: "Top" });
            return;
        }
        next();
    },
    beforeRouteLeave(to, from, next) {
        // 「入力内容を修正」ボタンや、ブラウザで戻られた場合に、入力項目を復元する
        const paramsCopy = JSON.parse(JSON.stringify(this.params));
        for (const entry of Object.entries(paramsCopy)) {
            to.params[entry[0]] = entry[1];
        }

        next();
    },
    methods: {
        formatDateCustom: function (date, format) {
            return this.$utils.formatDate(date, format);
        },
        formatDate: function (date) {
            return this.$utils.formatDate(date, "yyyy/MM/dd");
        },
        formatCommafy: function (val) {
            return this.$utils.commafy(val);
        },

        modifyContent: async function (pagaName) {
            // パラメータはbeforeRouteLeaveで設定
            this.$router.push({
                name: pagaName
            });
        },

        confirm: function () {
            if (this.params.isRequiredCredit) {
                // 支払い画面へ遷移
                this.$router.push({
                    name: "Payment"
                });
                return;
            } else {
                this.$emit(
                    "openConfirmYesModal",
                    "この内容で申し込みをしてもよろしいですか？ボタン押下後はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。",
                    async () => {
                        if (await this.checkDeliveryDate()) {
                            this.complete();
                        } else {
                            this.$emit("openAlertModal", "配送可能日が変更されました。配送可能日を変更してください。", () => {
                                this.$router.push({
                                    name: "SetupEmoForm"
                                });
                            });
                        }
                    },
                    () => {
                        // いいえの場合は処理しない
                        return;
                    }
                );
            }
        },
        checkDeliveryDate: async function () {
            return new Promise((resolve) => {
                let prefecture = this.params.customerPrefecture;
                let city = this.params.customerCity + this.params.customerAddress;
                if (!this.params.copyAddress) {
                    prefecture = this.params.destinationPrefecture;
                    city = this.params.destinationCity + this.params.destinationAddress;
                }
                this.$emit("showSpinner", "処理中です");
                this.$axios(
                    "POST",
                    "/contractConfirm/deliveryInfo",
                    {
                        prefecture: prefecture,
                        city: city
                    },
                    (res) => {
                        this.$emit("hideSpinner");
                        const deliveryDates = res.data.deliveryDates;
                        // 選択した日付が含まれるかチェックする
                        if (!deliveryDates[this.params.deliveryDate]) {
                            resolve(false);
                        } else {
                            resolve(true);
                        }
                    }
                );
            });
        },
        complete: function () {
            this.$emit("showSpinner", "処理中です。処理中はブラウザの「戻る」ボタンや「更新」ボタンを押さないでください。");
            this.$axios(
                "POST",
                "/contractConfirm/subscription",
                {
                    customer: {
                        email: this.params.customerEmail,
                        name: this.params.customerName,
                        kana: this.params.customerKana,
                        ageGroup: this.params.ownerAgeGroup,
                        gender: this.params.ownerGender,
                        postalCode: this.params.customerPostalCode,
                        prefecture: this.params.customerPrefecture,
                        city: this.params.customerCity,
                        address: this.params.customerAddress,
                        tel: this.params.customerTel
                    },
                    destination: {
                        name: this.params.copyAddress ? this.params.customerName : this.params.destinationName,
                        kana: this.params.copyAddress ? this.params.customerKana : this.params.destinationKana,
                        postalCode: this.params.copyAddress ? this.params.customerPostalCode : this.params.destinationPostalCode,
                        prefecture: this.params.copyAddress ? this.params.customerPrefecture : this.params.destinationPrefecture,
                        city: this.params.copyAddress ? this.params.customerCity : this.params.destinationCity,
                        address: this.params.copyAddress ? this.params.customerAddress : this.params.destinationAddress,
                        tel: this.params.copyAddress ? this.params.customerTel : this.params.destinationTel
                    },

                    product: this.params.product,
                    productId: document.productId,
                    planId: this.params.planId,
                    code: this.params.code,
                    promotionCode: this.params.promotionCode,
                    monthAmount: this.params.monthAmount,
                    durationInMonths: this.params.durationInMonths,

                    ownerGender: this.params.ownerGenderLabel,
                    ownerPrefecture: this.params.ownerPrefecture,
                    ownerArea: this.params.ownerArea,
                    emoPersonality: this.params.emoPersonality,
                    emoUserName: this.params.emoUserNameText || this.params.emoUserName,
                    emoUserAgeGroup: this.params.emoUserAgeGroup,
                    emoUserGender: this.params.emoUserGenderLabel,
                    emoPrefecture: this.params.emoPrefecture,
                    emoArea: this.params.emoArea,
                    emoUserRelationship: this.params.emoUserRelationship,
                    emoUserRelationshipText: this.params.emoUserRelationshipText,
                    firstMessage: this.params.firstMessage,

                    ownerAnswer1: this.params.ownerAnswer1,
                    ownerAnswer1SubAnswer: this.params.ownerAnswer1SubAnswer,
                    ownerAnswer1Text: this.params.ownerAnswer1Text,

                    np: document.np,

                    deliveryDate: this.params.deliveryDate,
                    deliveryTime: this.params.deliveryTime,

                    emoUserUuid: this.params.emoUserUuid
                },
                // eslint-disable-next-line no-unused-vars
                (res) => {
                    this.$emit("hideSpinner");
                    // 申し込みフォーム画面へ遷移
                    this.params.invoice = res.data.invoice;
                    this.params.affiliatePath = res.data.affiliatePath;
                    this.$router.push({
                        name: "ContractComplete"
                    });
                }
            );
        },
        cancel: function () {
            this.$emit("openConfirmModal", "申込みをキャンセルしますか？", () => {
                // TOP画面へ遷移
                this.$router.push({
                    name: "Top",
                    params: {}
                });
            });
        }
    },
    data: function () {
        return {
            params: {},
            discountSubscription: 0
        };
    },
    created() {
        this.params = this.$route.params;

        // 割引額の計算(小数第一位を四捨五入)
        if (this.params.promotionCode && this.params.promotionCode.percentOff) {
            this.discountSubscription = Math.round((this.params.monthAmount * this.params.promotionCode.percentOff) / 100);
        } else if (this.params.promotionCode && this.params.promotionCode.amountOff) {
            this.discountSubscription = this.params.promotionCode.amountOff;
        }
    }
};
</script>
<style scoped>
label > img {
    width: 100px;
    height: auto;
}

.break-all {
    word-break: break-all;
}
</style>
